var map = {
	"./template.betgalaxy": 2063,
	"./template.betgalaxy.tsx": 2063,
	"./template.betprofessor": 1863,
	"./template.betprofessor.tsx": 1863,
	"./template.betroyale": 1864,
	"./template.betroyale.tsx": 1864,
	"./template.default": 708,
	"./template.default.tsx": 708,
	"./template.fiestabet": 1865,
	"./template.fiestabet.tsx": 1865,
	"./template.puntcity": 1866,
	"./template.puntcity.tsx": 1866,
	"./template.puntgenie": 1867,
	"./template.puntgenie.tsx": 1867,
	"./template.questbet": 1868,
	"./template.questbet.tsx": 1868,
	"./template.ts": 996,
	"./template.volcanobet": 1869,
	"./template.volcanobet.tsx": 1869,
	"./template.wellbet": 1870,
	"./template.wellbet.tsx": 1870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2792;